import React, { FC } from 'react';
import { Chip } from '@material-ui/core';

interface Props {
  onDelete: () => void;
  file: File;
  className?: string;
}

const FileView: FC<Props> = ({ className, file, onDelete }) => {
  return <Chip className={className} variant='outlined' size='small' label={file.name} onDelete={onDelete} />;
};

export default FileView;
